export const config = {
    phase: 'phase-2',
    avaliableDistricts: {
        '香港島': [
            "中環",
            "北角",
        ],
        '九龍': [
            "鑽石山",
            "九龍城",
            "旺角",
            "佐敦",
            "尖沙咀",
        ],
        '新界': [
            "屯門",
            "荃灣",
            "上水",
        ],
    },
    clinicOptions: [
        // { label: "中環腸胃肝臟中心 (李恒輝醫生)",   value: 13, phone: "2388 8430", address: "中環皇后大道中70號卡佛大廈20樓2006室", district: "中環", onlineBooking: 'https://www.finddoc.com/doctors/%E6%9D%8E%E6%81%92%E8%BC%9D%E9%86%AB%E7%94%9F-9109?itm_source=patient-care&itm_medium=clinic-page&itm_campaign=h-pylori' },
        { label: "健基醫療中心 (徐家堅醫生)", value: 15, phone: "3585 0888", address: "九龍尖沙咀廣東道5號海港城海洋中心12樓1227室", district: "尖沙咀", onlineBooking: 'https://www.finddoc.com/doctors/%E5%BE%90%E5%AE%B6%E5%A0%85%E9%86%AB%E7%94%9F-9972?itm_source=patient-care&itm_medium=clinic-page&itm_campaign=h-pylori' },
        // { label: "中環腸胃肝臟中心 (李恒輝醫生)",   value: 14, phone: "2388 8430", address: "中環皇后大道中70號卡佛大廈20樓2006室", district: "中環" },
        { label: "健基醫療中心 (徐家堅醫生)", value: 16, phone: "3585 0888", address: "九龍尖沙咀廣東道5號海港城海洋中心12樓1227室", district: "尖沙咀" },
        { label: "莊柏醫療 (黃金海岸分店)", value: 0, phone: "2618 0199", address: "屯門黃金海岸商場地下28號舖", district: "屯門" },
        { label: "莊柏醫療 (佐敦分店)", value: 1, phone: "2618 0266", address: "九龍佐敦彌敦道238號18樓", district: "佐敦" },
        { label: "莊柏醫療 (上水分店)", value: 2, phone: "2618 0888", address: "上水名都商場2樓41號舖", district: "上水" },
        { label: "莊柏醫療 (中環分店)", value: 3, phone: "2618 5611", address: "中環干諾道中 30-32號莊士大廈1樓101號舖", district: "中環", href: 'https://www.finddoc.com/doctors/%E8%8E%8A%E6%9F%8F%E9%86%AB%E7%99%82-%E4%B8%AD%E7%92%B0-%E9%A7%90%E8%A8%BA%E9%86%AB%E7%94%9F%E9%86%AB%E7%94%9F-9902?itm_source=patient-care&itm_medium=clinic-page&itm_campaign=h-pylori' },
        { label: "莊柏醫療 (置樂花園分店)", value: 4, phone: "2618 3197 ", address: "新界屯門置樂花園67號A鋪地下", district: "屯門", href: 'https://www.finddoc.com/practices/%E8%8E%8A%E6%9F%8F%E9%86%AB%E7%99%82-%E7%BD%AE%E6%A8%82%E8%8A%B1%E5%9C%92-8663?itm_source=patient-care&itm_medium=clinic-page&itm_campaign=h-pylori' },
        { label: "莊柏醫療 (九龍城分店)", value: 5, phone: "2766 1033", address: "九龍城獅子石道17號地下", district: "九龍城" },
        { label: "莊柏醫療 (新都大廈分店)", value: 6, phone: "2613 2963", address: "新界屯門屯利街新都大廈地下102號舖", district: "屯門" },
        { label: "莊柏醫療 (新墟分店)", value: 7, phone: "2618 3058", address: "新界屯門仁政街2-4號年旺樓地下1號舖", district: "屯門" },
        { label: "莊柏醫療 (荃灣分店)", value: 8, phone: "2618 3805", address: "新界荃灣綠楊坊平台P10B號舖", district: "荃灣" },
        { label: "莊柏醫療 (旺角分店)", value: 9, phone: "2618 9510", address: "彌敦道700號T.O.P.商場15樓1502-1505室", district: "旺角" },
        { label: "柏宏醫務中心 (鑽石山分店)", value: 10, phone: "2618 5302", address: "九龍鑽石山荷里活廣場1樓116B舖", district: "鑽石山" },
        { label: "柏宏醫務中心 (北角分店) ", value: 11, phone: "2324 1112", address: "香港北角琴行街2C號愛琴軒地下1號舖", district: "北角" },
        { label: "中區醫務所 (黎則堯醫生)", value: 12, phone: "2521 2567", address: "香港中環太子大廈1501室", district: "中環" },
        // { label: "愷頤家庭醫學中心", value: 17, phone: "2333 2287", address: " 香港中環干諾道中13-14號歐陸貿易中心9樓902B室", district: "中環" },    
    ],
    references: [
        {
            text: "Adler I, Muiño A, Aguas S, et al. Helicobacter pylori and oral pathology: relationship with the gastric infection. World J Gastroenterol. 2014;20(29):9922-9935.",
        },
        {
            text: "Hooi JKY, Lai WY, Ng WK, et al. Global Prevalence of Helicobacter pylori Infection: Systematic Review and Meta-Analysis. Gastroenterology. 2017;153(2):420-429.",
        },
        {
            text: "Helicobacter pylori and Peptic Ulcer Disease, The Key to Cure. Cdc.gov. Accessed July 6,2021.",
            href: "https://www.cdc.gov/ulcer/keytocure.htm#symptoms",
        },
        {
            text: "Helicobacter Pylori. Hopkinsmedicine.org. Accessed July 5, 2021.",
            href: "https://www.hopkinsmedicine.org/health/conditions-and-diseases/helicobacter-pylori",
        },
        {
            text: "Malaty HM. Epidemiology of Helicobacter pylori infection. Best Pract Res Clin Gastroenterol. 2007;21(2):205-214.",
        },
        {
            text: "Herrero R, Park JY, Forman D. The fight against gastric cancer - the IARC Working Group report. Best Pract Res Clin Gastroenterol. 2014;28(6):1107-1114.",
        },
        {
            text: "Garza-González E, Perez-Perez GI, Maldonado-Garza HJ, Bosques-Padilla FJ. A review of Helicobacter pylori diagnosis, treatment, and methods to detect eradication. World J Gastroenterol. 2014;20(6):1438-1449",
        },
        {
            text: "Ferwana M, Abdulmajeed I, Alhajiahmed A, et al. Accuracy of urea breath test in Helicobacter pylori infection: meta-analysis. World J Gastroenterol. 2015;21(4):1305-1314",
        },
        {
            text: "H. pylori (Helicobacter pylori ) Breath Test: What is It, How is it Done. Clevelandclinic.org. Accessed July 7, 2021",
            href: "https://my.clevelandclinic.org/health/diagnostics/5217-h-pylori-helicobacter-pylori-breath-test--urea-breath-test",
        },
        {
            text: "Eisdorfer I, Shalev V, Goren S, Chodick G, Muhsen K. Sex differences in urea breath test results for the diagnosis of Helicobacter pylori infection: a large cross-sectional study. Biol Sex Differ. 2018;9(1):1",
        },
        {
            text: "Randel A. H. pylori Infection: ACG Updates Treatment Recommendations. Am Fam Physician. 2018;97(2):135-137",
        },
        {
            text: "Gastrointestinal Society. Diet for ulcer disease. Badgut.org. Published August 15, 2014. Accessed July 7, 2021.",
            href: "竹ttps://badgut.org/information-centre/health-nutrition/diet-for-ulcer-disease/",
        },
        {
            text: "Centers for Disease Control and Prevention. (1998). Helicobacter pylori : fact sheet for health care providers. Centers for Disease Control and Prevention.",
            href: "https://stacks.cdc.gov/view/cdc/40603",
        },
        {
            text: "White J, Winter J, Robinson K. Differential inflammatory response to Helicobacter pylori infection: etiology and clinical outcomes. Journal of Inflammation Research. 2015;8:137-147.",
            href: "https://doi.org/10.2147/JIR.S64888",
        },
    ]
}